import { CLEAR_BANK_DETAILS_DATA, GET_BANK_DETAILS_DATA } from "../../constants/bankDetails/BankDetailsConst"

const initialState = {
    UserBankDetails: null
}
export const GetBankDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_BANK_DETAILS_DATA:
            return {
                ...state,
                UserBankDetails: action.payload,
            }
        case CLEAR_BANK_DETAILS_DATA:
            return {
                ...state,
                UserBankDetails: null,
            }
        default:
            return state
    }
}  